import { env } from '../env'

// A stored file is a key, so it gets the public prefix. A value that already
// carries a scheme is a preview image the admin never uploaded, and is left alone.
export const displayS3File = (fileName: string) => {
  if (/^(https?:|data:|blob:)/.test(fileName)) return fileName
  return `${env.VITE_PUBLIC_URL}/s3-files/${fileName}`
}

// The same file on the admin's own origin. fetch() needs it: the end-user origin above sends
// no CORS header, so a script read from the admin fails while an <img> still renders.
export const sameOriginS3File = (fileName: string) =>
  `${env.VITE_S3_URL}/${fileName}`

export const defaultImage =
  'https://pbs.twimg.com/media/DyItmNtWoAAkwGi?format=jpg&name=4096x4096'
